import { useEffect } from 'react'
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update'
import { Capacitor } from '@capacitor/core'

/**
 * Checa, uma vez por abertura do app (cold start), se existe uma versão mais
 * nova publicada na Play Store e força atualização imediata (fluxo bloqueante
 * em tela cheia do próprio Google Play) quando existir.
 *
 * Só roda em Android nativo via Capacitor — em web/navegador não faz nada
 * (Capacitor.isNativePlatform() já retorna false ali). Não fala com o backend
 * nem com o nginx: conversa direto com os servidores do Google Play.
 */
export function useForceUpdate() {
  useEffect(() => {
    if (Capacitor.isNativePlatform() !== true) return

    const checarAtualizacao = async () => {
      try {
        const info = await AppUpdate.getAppUpdateInfo()
        if (info.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) return
        await AppUpdate.performImmediateUpdate()
      } catch {
        // Falha ao checar/disparar atualização (sem Play Store instalada, sem
        // rede, app fora da Play Store, etc.) — não bloqueia o uso do app.
      }
    }

    checarAtualizacao()
  }, [])
}
